import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect, getVal, isEmpty } from 'react-redux-firebase';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import ExpandableItem from '../../components/expandable-item';
import Indicator from '../../components/indicator';
import withDatabase from '../../hocs/with-database';

class QandAList extends PureComponent {
  render() {
    const { items, styles} = this.props;
 
    if (isEmpty(items)) {
      return <Indicator spin />;
    }
    return items
      .filter(
        (item, index) => !this.props.maxLength || index < this.props.maxLength
      )
      .map(({ q, a }, index) => (
        <ExpandableItem key={index} label={q} styles={styles}>
          <div dangerouslySetInnerHTML={{ __html: a }} />
        </ExpandableItem>
      ));
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ firebase }, { paths }) => {
  return {
    paths,
    items: []
      .concat(...paths.map(path => getVal(firebase.data, path)))
      .filter(Boolean)
  };
};

export default compose(
  withDatabase,
  connect(mapStateToProps, null),
  firebaseConnect(({ paths }) => paths)
)(QandAList);

QandAList.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.string).isRequired,
  maxLength: PropTypes.number
};
